import React, { Component } from "react";

class NotificationProps {
    message?: any | null;
    className?: string | null;
}

class NotificationState {}

class Notification extends Component<NotificationProps, NotificationState> {

    render() {
        if (!this.props.message) {
            return <></>;
        }

        let message = '';
        if (this.props.message instanceof Error) {
            message = this.props.message.message;
        } else if (typeof this.props.message == 'string') {
            message = this.props.message;
        } else {
            message = 'Internal error';
            console.error('Unhandled notification: ' + this.props.message)
        }

        return (
            <div className={"notification is-danger" + (this.props.className ? ' ' + this.props.className : '')}>
                {message}
            </div>
        );
    }
}

export default Notification;
